import API from './phx';
import * as utils from '../utils/OrderUtils';

const addAdminComment = async (orderId, message, user) => {
  const fetchUrl = utils.appendGeoParam(`/orders/${orderId}/comments_admin`);
  try {
    const response = await API.post(fetchUrl, {
      message,
      name: user,
      created: utils.getTimeInUTC(),
    });
    return response.data;
  } catch (error) {
    console.error('Error adding admin comment:', error);
    throw error;
  }
};

export default addAdminComment;
